/**
 * Stored files are addressed by their storage key (`users/<id>/audio/<key>.peaks.json`)
 * relative to a host-dependent origin: the public CDN in the cloud, the kernel's
 * `/api/storage` locally (spec §16.3). Hardcoding the CDN here made a local kernel fetch
 * waveforms and chords from the cloud — egress from an offline host, and a 404 once the
 * cloud object is gone.
 */
export const storedFileUrl = ({ storageBaseUrl, storagePath }: { storageBaseUrl: string; storagePath: string }) =>
  `${storageBaseUrl.replace(/\/+$/, '')}/${storagePath.replace(/^\/+/, '')}`
